import { render } from "./BannerSummary.vue?vue&type=template&id=50c60ab4"
import script from "./BannerSummary.vue?vue&type=script&lang=js"
export * from "./BannerSummary.vue?vue&type=script&lang=js"

import "./BannerSummary.vue?vue&type=style&index=0&id=50c60ab4&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__